/**
 * The title block of the app header: the page title and the one-line caption under it. A route with
 * no title key shows the app name; one with no caption leaves the line empty instead of collapsing
 * it, so the header keeps its height from page to page.
 */
import { useT } from '../i18n/language-provider'
import { titleKeyForPath } from './nav-config'
import { subtitleKeyForPath } from './page-subtitles'

export function PageTitleBlock({ pathname }: { pathname: string }) {
  const t = useT()
  // A typed or external link can end in a slash (/leave/); the router still opens the page.
  const path = pathname.replace(/\/+$/, '') || '/'
  const titleKey = titleKeyForPath(path)
  const subtitleKey = subtitleKeyForPath(path)
  return (
    <div className="min-w-0 flex-1">
      <h1 className="truncate text-lg font-bold text-fg">{titleKey ? t(titleKey) : t('layout.appName')}</h1>
      <p id="layout-page-subtitle" className="h-4 truncate text-xs text-muted">{subtitleKey ? t(subtitleKey) : null}</p>
    </div>
  )
}
